export const HR_EMPLOYEE_BREADCRUMB_EVENT = 'zy-hr:employee-breadcrumb-updated';

const employeeTitleCache = new Map<string, string>();

export function getHrEmployeeBreadcrumbTitle(uuid?: string) {
  if (!uuid) {
    return '';
  }
  return employeeTitleCache.get(uuid) || '';
}

export function setHrEmployeeBreadcrumbTitle(uuid?: string, title?: string) {
  if (!uuid || !title?.trim()) {
    return;
  }

  employeeTitleCache.set(uuid, title.trim());

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(HR_EMPLOYEE_BREADCRUMB_EVENT));
  }
}
